var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-date-picker',{class:_vm.className,attrs:{"value":_vm.value,"type":"date","placeholder":_vm.placeholder || _vm.$t('message.datas'),"size":_vm.size,"format":_vm.dateFormat,"value-format":_vm.valueFormat},on:{"input":_vm.dispatch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }